import { TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { Dispatch, useCallback } from "react";
import { HeldEmailQueueAction } from "../../../hooks/admin/useHeldEmailQueueState";

interface Props {
  value: string;
  dispatch: Dispatch<HeldEmailQueueAction>;
}

export function HeldEmailRecipientFilter({ value, dispatch }: Props) {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) =>
      dispatch({ type: "recipient", value: event.currentTarget.value }),
    [dispatch]
  );
  return (
    <TextInput
      label="Search recipient"
      leftSection={<IconSearch size={16} />}
      onChange={handleChange}
      placeholder="name@example.com"
      value={value}
    />
  );
}
